import api from "../../index";

export const GetDeleteClientApi = () => api.post("get-deleted-clients");
export const RestoreDeletedClient = (data) => api.post("restore-deleted-client", data);
export const GetDeleteOrganizerApi = () => api.post("get-deleted-organizer");
export const RestoreDeletedOrganizer = (data) => api.post("restore-deleted-organizer", data);
